var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"car-info__no-access"},[(!_vm.userAccess.scEditCarWithFreeSaldoFlag && _vm.freeSaldoFlag)?[_vm._v(" Заблокировано на изменение из-за включенного \"Бесплатного проезда\". ")]:[_vm._v(" У Вас недостаточно прав для просмотра карточки данного автомобиля. ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }